import { get, post, destroy, put } from ".";

// Integration Login
export function AcknowledgeVinLoginEnforcement() {
    return post<any>("/app/api/integration_app/acknowledge_vin_login_enforcement", {});
}
export function IntegrationsLogin(options: any) {
    return post<any>("/app/api/integration_app/login", options);
}
export function IntegrationsSubmitMfa(options: any) {
    return post<any>("/app/api/integration_app/submit_mfa", options);
}

// Integration Users
export function GetIntegrationUser() {
    return get<any>("/app/api/integration_app/user");
}
export function CreateIntegrationUser(options: any) {
    return post<any>("/app/api/integration_app/user", options);
}

// Integration Appointments
export function GetIntegrationAppointments(options: any) {
    return get<any>("/app/api/integration_app/appointments", options);
}
export function GetIntegrationAppointment(key) {
    return get<any>("/app/api/integration_app/appointments/" + key);
}
export function GetIntegrationAppointmentSlots(options = {}) {
    return get<any>("/app/api/integration_app/appointments/slots", options);
}
export function CancelIntegrationAppointment(appointmentSid: string, options = {}) {
    return destroy<any>(`/app/api/integration_app/appointments/${appointmentSid}`, options)
}
export function CreateIntegrationAppointment(options = {}) {
    return post<any>("/app/api/integration_app/appointments", options);
}
export function UpdateIntegrationAppointment(id, options = {}) {
    return put<any>(`/app/api/integration_app/appointments/${id}`, options)
}

// Integration Customers
export function GetIntegrationCustomers(options = {}) {
    return get<any>("/app/api/integration_app/customers", options);
}
export function CreateIntegrationCustomer(options = {}) {
    return post<any>("/app/api/integration_app/customer", options);
}

// Integration Vehicles
export function FindOrCreateIntegrationVehicle(options = {}) {
    return get<any>("/app/api/integration_app/vehicle/find_or_create", options);
}

// Integration Misc
export function GetIntegrationTransportationTypes(options = {}) {
    return get<any>("/app/api/integration_app/transportation_types", options);
}
export function GetIntegrationServiceAdvisors(options = {}) {
    return get<any>("/app/api/integration_app/service_advisors", options);
}
export function GetIntegrationServiceShops(options = {}) {
    return get<any>("/app/api/integration_app/service_shops", options);
}
export function GetIntegrationOpcodes(options = {}) {
    return get<any>("/app/api/integration_app/opcodes", options);
}
export function GetIntegrationServiceMenu(options = {}) {
    return get<any>("/app/api/integration_app/service_menu", options);
}